/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Kb2Inputs */

const en_mk_cmp_notion_kb2 = /** @type {(inputs: Mk_Cmp_Notion_Kb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents appear in the assignee list next to people.`)
};

const id_mk_cmp_notion_kb2 = /** @type {(inputs: Mk_Cmp_Notion_Kb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen muncul di daftar penanggung jawab bersama manusia.`)
};

/**
* | output |
* | --- |
* | "Agents appear in the assignee list next to people." |
*
* @param {Mk_Cmp_Notion_Kb2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_kb2 = /** @type {((inputs?: Mk_Cmp_Notion_Kb2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Kb2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_kb2(inputs)
	return en_mk_cmp_notion_kb2(inputs)
});